import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface StatusPageComponent {
  id: string;
  name: string;
  status: string;
  description: string | null;
  showcase: boolean;
  group: boolean;
}

export interface StatusPageData {
  overall_status: {
    indicator: string;
    description: string;
  };
  components: StatusPageComponent[];
  active_incidents: any[];
  scheduled_maintenances: any[];
  page_info: {
    name: string;
    url: string;
    updated_at: string;
  };
  fetched_at: string;
}

export const useStatusPage = (componentId: string) => {
  return useQuery({
    queryKey: ['statuspage', componentId],
    queryFn: async (): Promise<StatusPageData> => {
      const { data, error } = await supabase.functions.invoke('get-status', {
        body: { componentId }
      });

      if (error) {
        throw error;
      }

      return data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 15000, // Consider data stale after 15 seconds
    enabled: !!componentId,
  });
};